import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as func from "../../common/athleteCommon/FunctionCalls";

interface Props {
    formData: any;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const PhysiologicalProfile: React.FC<Props> = ({ formData, onChange }) => {

    // const physioList = [{ physioId: 1, physioName: "History of chest pain during exertion" }, { physioId: 2, physioName: "History of fainting" }, { physioId: 3, physioName: "History of Asthma" }, { physioId: 4, physioName: "History of Heart murmur" }, { physioId: 5, physioName: "History of Seizures" }, { physioId: 6, physioName: "History of Heat illness" }]

    const [physioList, setPhysioList] = useState<any[]>([]);

    useEffect(() => {
        async function getPhysioType() {
            const physioResponse = await func.physiologicalType(null);
            setPhysioList(Array.isArray(physioResponse) ? physioResponse : []);
        }
        getPhysioType()
    }, [])

    const handleSelectChange = (name: string) =>
        (option: any) => {
            const value = Array.isArray(option)
                ? option.map(o => o.value)
                : option?.value ?? "";

            onChange({
                target: { name, value }
            } as React.ChangeEvent<HTMLInputElement>);
        };

    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">

                    <div className="row">
                        <div className="col-lg-4">
                            <h4>Is there no Physiological history?</h4>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-check form-switch d-flex align-items-center justify-content-start">
                                <input
                                    className="form-check-input text-end"
                                    type="checkbox"
                                    checked={formData.noHistory === '1'}
                                    name="noHistory"
                                    // onChange={onChange}
                                    onChange={(e) =>
                                        onChange({
                                            target: {
                                                name: "noHistory",
                                                value: e.target.checked ? "1" : "0"
                                            }
                                        } as React.ChangeEvent<HTMLInputElement>)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    {(formData.noHistory != "1") ?
                        <>
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label">Physiological Profile</label>
                                    <Select
                                        isMulti
                                        value={Array.isArray(physioList)
                                            ? physioList
                                                .filter(physio => formData.physiological.includes(physio.physiologicalTypeId))
                                                .map(physio => ({
                                                    value: physio.physiologicalTypeId,
                                                    label: physio.name
                                                }))
                                            : []
                                        }
                                        onChange={handleSelectChange("physiological")}
                                        options={Array.isArray(physioList)
                                            ? physioList.map(physio => ({
                                                value: physio.physiologicalTypeId,
                                                label: physio.name
                                            }))
                                            : []
                                        }
                                    />
                                </div>
                            </div>
                        </> : null}
                </div>
            </div>
        </>
    );
};

export default PhysiologicalProfile;